// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const ellipse = "PieChart__ellipse__Hpm6Y";
export const sector = "PieChart__sector__qOnJJ";
export const shaded = "PieChart__shaded__MpDNV";
export const text = "PieChart__text__H8VCI font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";
export const tooltip = "PieChart__tooltip__tr9Sb";
export const shown = "PieChart__shown__6jp06";